<template>
  <el-select v-model="form.category" name="category" :loading="loading" filterable placeholder="Select a category" @change="$emit('input', $event)">
    <el-option-group v-for="(categories, title) in groups" :key="title" :label="title">
      <el-option v-for="category in categories" :key="category.id" :label="category.title" :value="category.id"></el-option>
    </el-option-group>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      groups: [],
      form: {
        category: this.value,
      },
    }
  },

  props: {
    value: {
      default: null,
      type: String,
    },
  },

  async mounted() {
    this.loading = true

    try {
      var { data } = await this.$http.get('/categories')
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }

    this.groups = data
  },
}
</script>
